import { render, staticRenderFns } from "./store_set_deposit.vue?vue&type=template&id=ca71a4ba&scoped=true"
import script from "./store_set_deposit.vue?vue&type=script&lang=js"
export * from "./store_set_deposit.vue?vue&type=script&lang=js"
import style0 from "./store_set_deposit.vue?vue&type=style&index=0&id=ca71a4ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca71a4ba",
  null
  
)

export default component.exports